import React from "react";
import { sharedApiService } from "../api-services/sharedApiServices";
import CustomButton from "@/src/lib/ui/Button";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error:", error);
        console.error("Error Info:", errorInfo);
        this.setState({ hasError: true, error });

        const errorLog = {
            sourcePagePath: window.location.pathname,
            errorMessage: error?.message || "Unknown error",
            errorDescription: errorInfo.componentStack || "Unknown error",
            errorCode: error.response
                ? error.response.status.toString()
                : "XXX",
        };

        sharedApiService
            .saveErrorLogData(errorLog)
            .then((res) => {
                console.log("Error log saved successfully");
            })
            .catch((err) => {
                console.error("Error saving error log", err);
            });

        if (typeof gtag === "function") {
            gtag("event", "exception", {
                description: error?.message || "Unknown error",
                fatal: false, // set to true if the error is fatal
            });
        } else {
            console.warn("gtag is not defined");
        }
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    className="max-w-6xl mx-auto"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100vh",
                        padding: "0 20px",
                    }}
                >
                    <h4 className="md:text-6xl sm:text-4xl text-2xl font-bold mb-4 text-center text-gray-200">
                        Something went wrong!!!
                    </h4>
                    <p className="text-gray-700 md:text-xl sm:text-lg text-base text-sm mb-5 text-center animate-bounce">
                        There was an error. Please try again later.
                    </p>

                    <CustomButton
                        onClick={this.handleRetry}
                        className="bg-zinc-700 hover:bg-zinc-800 text-white font-sm rounded-md cursor-pointer px-4 py-2"
                    >
                        Retry
                    </CustomButton>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
